import FilterCheckList from "components/FilterCheckList";
import { FilterSimpleSelect } from "components/FilterSimpleSelect";
import { useField } from "lib/form";
import { device, mq } from "lib/media-query";
import React from "react";
import { useFilter } from "services/filter";
import styled from "styled-components";
import { getMinOptions, getMaxOptions } from "./getYearsOptions";

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;

    ${mq.to(device.TABLET)`
     grid-template-columns: 1fr;
  `};
    ${({ condensed }) => (condensed ? "grid-template-columns: 1fr" : "")}
`;

const names = {
    OCCASION: "Gebruikt",
    NIEUW: "Nieuw"
};

const previousYear = String(new Date().getFullYear() - 1) || "";

function resolveAutoSoortConfig(autosoort) {
    if (autosoort.length === 0) {
        return {
            minBj: [],
            maxBj: [],
            minKm: [],
            maxKm: []
        };
    }
    return autosoort[0] === "OCCASION"
        ? {
              minBj: [],
              maxBj: [`${previousYear}`],
              minKm: ["500"],
              maxKm: []
          }
        : {
              minBj: [`${previousYear}`],
              maxBj: [],
              minKm: [],
              maxKm: ["500"]
          };
}

export const BouwjaarFilter = ({ condensed }) => {
    const filter = useFilter("soortAuto");
    const [minBjValue, , onMinBjChange] = useField("minimumbouwjaar");
    const [maxBjValue, , onMaxBjChange] = useField("maximumbouwjaar");
    const [, , onMinKmChange] = useField("minimumkilometerstand");
    const [, , onMaxKmChange] = useField("maximumkilometerstand");
    const [kindValue, , onKindValueChange] = useField("autosoorten");

    const kindOptions = filter.map((kind) => ({
        id: kind,
        displayName: names[kind]
    }));

    const onCheckListChange = (val) => {
        const { minBj, maxBj, minKm, maxKm } = resolveAutoSoortConfig(val);

        onKindValueChange(val);
        onMinBjChange(minBj);
        onMaxBjChange(maxBj);
        onMinKmChange(minKm);
        onMaxKmChange(maxKm);
    };

    return (
        <Grid condensed={condensed}>
            <div>
                <FilterSimpleSelect
                    filterId="filter-bouwjaar-min"
                    options={getMinOptions(maxBjValue)}
                    value={minBjValue}
                    handleChange={(_, value) => onMinBjChange(value)}
                    datalayerKey="bouwjaar.min"
                    helpText="Van"
                    classes="left"
                />
                <FilterSimpleSelect
                    filterId="filter-bouwjaar-max"
                    options={getMaxOptions(minBjValue)}
                    value={maxBjValue}
                    handleChange={(_, value) => onMaxBjChange(value)}
                    datalayerKey="bouwjaar.max"
                    helpText="Tot"
                    classes="right"
                />
            </div>
            <FilterCheckList
                filterId="filter-autosoort"
                options={kindOptions}
                value={kindValue}
                handleChange={(_, value) => onCheckListChange(value)}
                columns={2}
                datalayerKey="autosoort"
                maxSize={0}
                isSingle
            />
        </Grid>
    );
};
